<template lang="pug">
.page-view
  router-view
</template>
<script>

export default {
  name: 'App',
  data(){
    return {
      timeoutMin: 10,
      myTimeout: null
    }
  },
  mounted(){
    this.resetTimer()
    addEventListener('click', () => {
      this.resetTimer()
    });
  },
  methods: {
    resetTimer(){
      if (this.myTimeout) clearTimeout(this.myTimeout)
      this.myTimeout = setTimeout(() => {
        clearTimeout(this.myTimeout)
        this.$router.push('/')
      }, this.timeoutMin * 1000 * 60)

    }
  }
}
</script>

<style>
@font-face {
  font-family: Siemens Sans;
  src: url(assets/fonts/siemens-sans-roman.woff) format("woff");
  font-display: fallback;
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: Siemens Sans Bold;
  src: url(assets/fonts/siemens-sans-bold.woff) format("woff");
  font-display: fallback;
  font-style: normal;
  font-weight: 700;
}
@font-face {
  font-family: Siemens Slab;
  src: url(assets/fonts/SiemensSlab-Roman.woff) format("woff");
  font-display: fallback;
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: siemens-webicons-webfont;
  src: url(assets/fonts/siemens-webicons-webfont.woff) format("woff");
  font-display: fallback;
  font-style: normal;
  font-weight: 400;
}
body, html, #app, .container, .page-view {
  touch-action: pan-x pan-y;
  font-family: Siemens Sans,sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  word-break: break-word;
  width: 100%;
  background-color: #000028;
  margin: 0px;
  padding: 0px;
  color: #fff;
  font-size: 16px;
  height:100%;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  
}
/*@media screen and (orientation: landscape) {
.page-view{
  display: none;
}
}*/


.row{
  height: 100%;
  width: 100%;
}
.col-6{
  height: 100%;
  width: 60%;
  float: left;
}
.col-4{
  height: 100%;
  width: 40%;
  float: left;
}
.page h2 {
  font-size: 100px;
  background: linear-gradient(90deg,#00ffb9,#00e6dc);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: Siemens Sans Bold,sans-serif;
  letter-spacing: .5px;
  margin-bottom: 0px;
  display: block;
}
.page h3 {
  font-size: 68px;
  margin-top: 5px;
  margin-bottom: 0px;
  font-family: Siemens Sans Bold,sans-serif;
  display: block;
  color: #bbc5c5;
}
.container{
  margin-left: 65px;
  margin-right: 65px;
  width: calc(100% - 130px);
  height: 100%;
  background: none;
}

.titelbild{
  max-height: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.bg-img{
  height: 100%;
  background-image:  url(assets/img/bg.jpg);
}
.wrapper{
  height: calc(100% - 80px);
  display: flex;
  align-items: center;
}
.detail-page{
  margin: 20px;
}
.inner{
  padding-top: 100px;
  padding-left: 40px;
}
.content {
  flex: 1;
  height: calc(100% - 80px);
  display: flex;
  align-items: center;
}
.wrapper{
  display: flex;
  align-items: center;
}

h1 {
  margin: 0px;
  padding-top: 35px;
}
svg.a-link__icon {
  height: 80px;
  width: 80px;
  top: 20px;
  position: relative;
  margin-right: 20px;
}

.menu-link{
  font-size: 68px;
  margin-bottom: 75px;
  font-weight: 700;
}
a {
  color: #fff;
  text-decoration: none;
}
.btn {
  color: #000028;
  font-family: Siemens Sans;
  font-size: 28px;
  font-weight: 800;
  letter-spacing: .5px;
  text-align: center;
  background-image: -webkit-gradient(linear,left top,right top,from(#00ffb9),to(#00e6dc));
  background-image: linear-gradient(90deg,#00ffb9,#00e6dc);
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  max-width: 80vw;
  text-decoration: none;
  padding: 25px 60px;
  margin-top: 100px;
  display: block;
  border: none;

}
.btn-sm{
  font-size: 46px;
  padding: 10px 20px;
  display: inline-block;
  margin: 10px;
  width: 75px;
  color: #000;
}
.btn-sm svg{
  color: #000;
  width: 60px;
  width: 40px;
  margin-left: -3px;
  margin-top: 10px;

}
.flexbox {
  display: flex;
}
.responsive {
  width: 100%;
  height: auto;
}
.card{
  padding: 20px;
  cursor: pointer;
}

.btn-right{
  position: absolute;
  z-index: 99;
  top: 55%;
  left: 80px;
}
.btn-left{
  position: absolute;
  z-index: 99;
  top: 55%;
  right: 80px;
}
.gallery{
  margin: 50px;
/*  height: 100%;*/
  text-align: center;
}
.gallery img {
  width: auto;
  height: 100%;
}

.glide__bullets {
    -ms-flex-align: center;
    align-items: center;
    z-index: auto;
    bottom: 1.5em;
}
.glide__bullets {
    position: absolute;
    z-index: 2;
    left: 50%;
    display: -ms-inline-flexbox;
    display: inline-flex;
    list-style: none;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
}

.glide__bullets .glide__bullet--active {
    width: 1em;
    height: 1em;
    background: -webkit-gradient(linear,left top,right top,from(#50bebe),color-stop(50%,#099),color-stop(83%,#0099b0),to(#0099cb));
    background: linear-gradient(90deg,#50bebe,#099 50%,#0099b0 83%,#0099cb);
}
.glide__bullets .glide__bullet {
    background-color: #d8d8d8;
    border: none;
    margin: 0 0.5em;
    vertical-align: middle;
    width: 1.5em;
    height: 1.5em;
    -webkit-transition: none;
    transition: none;
}

.glide__bullet {
    background-color: hsla(0,0%,100%,.5);
    width: 9px;
    height: 9px;
    padding: 0;
    border-radius: 50%;
    border: 2px solid transparent;
    -webkit-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;
    cursor: pointer;
    line-height: 0;
    -webkit-box-shadow: 0 0.25em 0.5em 0 rgb(0 0 0 / 10%);
    box-shadow: 0 0.25em 0.5em 0 rgb(0 0 0 / 10%);
    margin: 0 0.25em;
}
@media (max-width: 1200px) {
  .col-6{
    width: 100%;
  }
  .col-4{
    width: 100%;
  }
  .page h2 {
    margin-left: 0px;
    font-size: 38px;
  }
  .page h3 {
    font-size: 28px;
  }
  .container{
    width: 100%;
    margin:0px;
  }
 .content{
    margin-left: 10px;
    margin-right: 10px;

}
  .inner {
        margin-left: 0px;
    margin-right: 20px;
  }

  .wrapper, .content{
    height: 100%;
    width: 100%;
  }

  .btn {
    font-size: 22px;
    padding: 15px 30px;
  }
  .menu-link {
    font-size: 28px;
  }
  .detail-page, .gallery {
    margin: 0px;
  }
  .gallery img {
    width: 100%;
    height: auto;
  }
  .gallery{
    margin: 10px;
  }

  .glide__bullets .glide__bullet {
      margin: 0 0.5em;
      width: 1em;
      height: 1em;
  } 
  .page h2 {
    margin-bottom: 20px;
  }
  h2 {
    margin-left: 10px;
  }
.btn-right{
  position: absolute;
  z-index: 99;
  top: 55%;
  left: 10px;
  padding: 0px;
}
.btn-left{
  position: absolute;
  z-index: 99;
  top: 55%;
  right: 10px;
  padding: 0px;
}
}
</style>
